/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum PageType {
  全屏 = 1,
  半屏,
  弹窗,
}
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=122804535
export const first_recharge_homopage = createAsyncThunk(
  'firstCharge/first_recharge_homepage',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/misc/first_recharge_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=174057055
export const repurchase_homepage = createAsyncThunk(
  '/live/misc/repurchase_homepage',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/misc/repurchase_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
export const getProductsList = createAsyncThunk(
  'firstCharge/getProductsList',
  async (param: any = {}, store: any) => {
    const {
      base: {payPrice},
    } = store.getState().FirstCharge
    // const resp = await http.post('/live/pay/get_products_list', {
    const resp = await http.post(
      '/live/pay/get_first_recharge_products_list',
      {
        ...store.getState().env.deviceinfo,
        ...param,
        before_recharged: 1,
        price: (payPrice * 100).toString(),
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
export const getRepurchaseProductsList = createAsyncThunk(
  '/get_repurchase_products_list',
  async (param: any = {}, store: any) => {
    const {
      base: {payPrice},
    } = store.getState().FirstCharge
    const resp = await http.post(
      '/live/pay/get_repurchase_products_list',
      {
        ...store.getState().env.deviceinfo,
        ...param,
        before_recharged: 1,
        price: (payPrice * 100).toString(),
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export const getRechargeBonus = createAsyncThunk(
  'firstCharge/getRechargeBonus',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/activity/recharge_bonus',
      {
        ...store.getState().env.deviceinfo,
        mid: store.getState().env.deviceinfo.h_m,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
export const createRechargeOrderV2 = createAsyncThunk(
  'firstCharge/createRechargeOrderV2',
  async (
    params: {
      product_id: string
      pay_method_id: number
      from: string
      code: number
      source: string
      from_page: string
      room_id?: number
      anchor_mid?: number
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/pay/create_order_h5_v2',
      {
        ...store.getState().env.deviceinfo,
        mid: store.getState().env.deviceinfo.h_m,
        ...params,
      },
      {
        xcHideLog: true,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
export interface RedirectInfo {
  redirect_url: string
  redirect_param: {[key: string]: string}
  redirect_method: 'get' | 'post'
}
interface ThirdPartyListItem {
  pay_method_id: number
  name: string
  img: string
  product: {
    product_id: string
    price: number
    coins: number
    currency: string
  }
}
const initialState: {
  base: {
    payPrice: string
  }
  home: {
    activity?: string // 拉起周卡的scheme
    version: string // v2新版本优化
    is_in_white_list: boolean
    count_down: number
    list?: Array<{
      is_focus: boolean
      price: string
      original_price: string
      coins: number
      bonus_range: Array<number>
      pri_list: Array<{
        reward_desc: string
        name: string
        icon: string
        type: number
        id: string
        preview_config: {
          img: string
          title: string
          desc: string
        }
      }>
      other_list: Array<{
        preview_config: {
          img: string
          title: string
          desc: string
        }
        id: string
        type: number // 1：头像框2：勋章 3：气泡 4、进场特效
        name: string
        reward_desc: string
        icon: string
      }>
      discount: number
    }>
    buyer_list: Array<{
      avatar: string
      gift_pack_desc: string
    }>
  }
  wallet: {
    official_product_id: string
    huawei_product_id: string
    countries: Array<{
      code: number
      name: string
    }>
    default_country: {
      code: number
      name: string
    }
    third_party_list: ThirdPartyListItem[]
  }
} = {
  base: {
    payPrice: '',
  },
  home: {
    version: 'v1',
    count_down: 0,
    is_in_white_list: false,
    list: [],
    buyer_list: [],
  },
  wallet: {
    official_product_id: '',
    huawei_product_id: '',
    countries: [],
    default_country: {
      code: 0,
      name: '',
    },
    third_party_list: [],
  },
}

export function useFirstCharge() {
  return useSelector((store) => store.FirstCharge)
}

export const FirstChargeSlice = createSlice({
  name: 'FirstCharge',
  initialState,
  reducers: {
    updatePayPrice: (state, action: PayloadAction<string>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          payPrice: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(first_recharge_homopage.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {home: data})
    })
    builder.addCase(first_recharge_homopage.rejected, (state, action) => {})
    builder.addCase(repurchase_homepage.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {home: data})
    })
    builder.addCase(repurchase_homepage.rejected, (state, action) => {})
    builder.addCase(getProductsList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {wallet: data})
    })
    builder.addCase(getRepurchaseProductsList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {wallet: data})
    })
  },
})

export default FirstChargeSlice.reducer
export const FirstChargeActions = FirstChargeSlice.actions
